import { RESET_PRODUCT, SET_IS_FETCHING_PRODUCT, SET_PRODUCT } from 'reducers/actions-types';
import axios from 'axios';
import { product as productURL } from 'constants/api-urls';

export default Object.freeze({
    /**
     *
     * @param {string} slug
     * @return {function(*): Promise<AxiosResponse<IProductDetail>>}
     */
    fetch(slug) {
        return function(dispatch) {
            dispatch({ type: SET_IS_FETCHING_PRODUCT, isFetching: true });

            return axios.get(productURL(slug))
                .then(
                    /**
                     * @param {IProductDetail} data
                     */
                    ({ data }) => {
                        dispatch({ type: SET_IS_FETCHING_PRODUCT, isFetching: false });
                        dispatch({ type: SET_PRODUCT, product: data });
                        return data;
                    })
                .catch(e => {
                    dispatch({ type: SET_IS_FETCHING_PRODUCT, isFetching: false });
                    return Promise.reject(e);
                });
        };
    },

    reset() {
        return { type: RESET_PRODUCT };
    },
});



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/product/actions.js